/** 거래 정보 클래스 */
export class Trade {
  constructor() {
    this.id = null;
    this.date = "";
    this.product_id = null;
    this.product_name = "";
    this.size = "";
    this.amount = null;
    this.unit_id = 1;
    this.cost = null;
    this.pyung_cost = null;
    this.item_processing_cost = null;
    this.supply_price = null;
    this.tax = null;
    this.price = null;
    this.desc = "";
    this.specification = null;
    this.options = null;
    // options로 정의하면 값 변경시 detect 할 수 없기 때문에
    // 상위에서 정의해 주고 대입해 준다.
    this.glass_pyung = 0;
    this.glass_color_id = null;
    this.glass_thickness_id = null;
    this.zipcode = null;
    this.destination = null;
  }
}
